module.exports = __webpack_public_path__ + "static/media/Team 26 - Green Nextdoor.b835367a.JPG";